import { useState, useRef, useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { AboutSection } from "@/components/AboutSection";
import { TreeList, TreeListRef } from "@/components/tree/TreeList";
import { Particles } from "@/components/Particles";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import "./index.css";

export function App() {
  const [expandedCount, setExpandedCount] = useState(0);
  const treeListRef = useRef<TreeListRef>(null);

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      setExpandedCount(e.detail.count);
    };
    window.addEventListener("tree-expand-change", handler as EventListener);
    return () => window.removeEventListener("tree-expand-change", handler as EventListener);
  }, []);

  const handleCollapseAll = () => {
    treeListRef.current?.collapseAll();
    setExpandedCount(0);
  };

  return (
    <div className="min-h-screen bg-black text-white relative">
      <Particles />
      <div className="noise-overlay" />
      <Navbar />
      <main className="relative z-10">
        <TreeList ref={treeListRef} />
        <AboutSection />
      </main>
      <SpeedInsights />
      <Analytics />
      {expandedCount > 1 && (
        <button
          onClick={handleCollapseAll}
          className="fixed bottom-6 right-6 z-40 px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white/70 hover:text-white text-sm rounded-full transition-colors"
        >
          Collapse All
        </button>
      )}
    </div>
  );
}

export default App;